import {useContext} from "react";
import {BaseThemeContext} from "@/theming/BaseThemeProvider";
import {OrganizationThemeContext} from "@/theming/OrganizationThemeProvider";

export const useCurrentTheme = () => {
    const organizationContext = useContext(OrganizationThemeContext);
    const baseContext = useContext(BaseThemeContext);

    // If we're inside an OrganizationThemeProvider, use that
    if (organizationContext) {
        return organizationContext;
    }

    // If we're inside a BaseThemeProvider but not OrganizationThemeProvider, use base
    if (baseContext) {
        return baseContext;
    }

    // If we're not inside any provider, throw an error
    throw new Error('useCurrentTheme must be used within a BaseThemeProvider or OrganizationThemeProvider');
};
